import Cookies from 'js-cookie'
import dayjs from 'dayjs'
import _ from 'lodash'
import KWLogin from 'kw-bweb-login'
// 需要保留的客服cookie
const customerCookie = [
  'imLoginName',
  'kcspSiteToken',
  'kcspSiteUserId',
  'sourceType',
  'buzzId',
  '_platform_num'
]

function getDomain(url) {
  const arr = url.split('/')
  return arr[2].split('.')[0]
}

const ensureLogin = () => {
  const buzzType = Cookies.get('buzzType')
  const buzzId = Cookies.get('buzzId')
  // const token = Cookies.get('siteToken') // 2022-04-24 安全修复，siteToken服务端设置为http-only，js读不到
  const userId = Cookies.get('siteUserId')
  // const platform_num = Cookies.get('_platform_num')
  if (buzzId && buzzType && userId ) {
    return true
  } else {
    toLogin()
  }
}

/**
 * event触发式下载
 * @param url {string} 下载url
 * @param ifSelf
 */
const openLink = (url, ifSelf = false) => {
  if (url && url !== '') {
    const downloadElement = document.createElement('a')
    downloadElement.href = url;
    downloadElement.target = ifSelf ? '_self' : '_blank';
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement);
  }
}

const getCookie = (k) => {
  return Cookies.get(k)
}

/**
 * 设置cookie
 * @param k
 * @param v
 * @param ext
 * @returns {*}
 */
const setCookie = (k, v, ext={}) => {
  const baseExt = { domain: 'haiziwang.com', expires: 10 }
  return Cookies.set(k, v, { ...baseExt, ...ext })
}

const setCookies = (name, value, iHours, domain = '.haiziwang.com') => {
  const oDate = new Date();
  oDate.setHours(oDate.getHours() + iHours);
  document.cookie = name + '=' + value + ';expires=' + oDate + ';domain=' + domain + ';path=/';
}

const toLogin = () =>{

  clearCookies()
  if (isLeYou) {
    const link = window.location.href
    location.href = `//shop.leyou.com/open/auth/leyoulogin?link=${encodeURIComponent(link)}`
  } else {
    KWLogin.toLogin('//open.haiziwang.com/mine/workbench')
  }
}

/**
 * 清楚所有cookie
 */
const clearCookies = (namespaces) => {
  const names = namespaces || Object.keys(Cookies.get())
  names.forEach(function(cookieName) {
    if(!customerCookie.includes(cookieName)) {
      if (isLeYou) {
        Cookies.remove(cookieName, { domain: 'leyou.com' })
      } else {
        Cookies.remove(cookieName, { domain: 'haiziwang.com' })
      }
    }
  });
}

// const tracker = (...args) => {
//   try {
//     window.track._launch(...args);
//   } catch (error) {
//     console.error(error)
//   }
// }

const isLeYou = /leyou/.test(window.location.hostname)

// 埋点上报
const tracker = (bizType, pageLevelId, logType=10000, clickId='', params={}) => {
  const bid = Cookies.get('buzzId') || ''
  const popid = Cookies.get('siteLoginName') || ''
  const btype = Cookies.get('buzzType') || ''
  const tenantnum = Cookies.get('_platform_num') || ''
  const pageParam = JSON.stringify({bid, popid, btype, tenantnum})
  const positionParam = JSON.stringify(_.omitBy(params, _.isNil))
  try{
    // bid, popid, btype 不存在不上报
    if (bid === '' || popid === '' || btype === '') {
      return
    }
    if(logType === 10000){
      window.track && window.track._launch(
        {
          bizType,
          pageLevelId,
          logType,
          clickId,
          pageParam
        }
      )
    }else{
      window.track && window.track._launch(
        {
          bizType,
          pageLevelId,
          logType,
          clickId,
          pageParam,
          positionParam
        }
      )
    }
  }catch(e){
    console.log(e)
  }
}

const cookieDate3Seconds = () => {
  let date = new Date();
  date.setTime(date.getTime() + 3 * 1000);
  return date;
}


const dateFormat = (timestmap, formatter = 'YYYY-MM-DD HH:mm:ss') => {
  return dayjs(timestmap).format(formatter)
}

// 基本图像处理接口
const imagePreview = (value, width, height, type, viewType) => {
  const view = viewType || '2'
  let imgUrl = `${value}?imageView2/${view}`
  if (width) {
      imgUrl = `${imgUrl}/w/${width}`
  }
  if (height) {
      imgUrl = `${imgUrl}/h/${height}`
  }
  if (type) {
      imgUrl = `${imgUrl}/q/85/format/${type}`
  } else {
      imgUrl = `${imgUrl}/q/85/format/jpg`
  }
  return imgUrl
}
// supportWebp() {
//   const ele = document.createElement('canvas');
//   ele.width = 1;
//   ele.height = 1;
//   return ele.toDataURL && ele.toDataURL('image/webp').indexOf('data:image/webp') === 0;
// },
// 图片压缩,
const viewImage = (value, width, height, type) => {
  let img = ''
  if (value) {
      value = value.replace(/^http(s?):/, '')
      // if (isSupportWebp) {
      //     img = utils.imagePreview(value, width, height, 'webp')
      // } else {
          img = imagePreview(value, width, height, type)
      // }
  }
  return img
}

const CUSTOME_TRACE_ID = 'trace-cxid'

export {
  cookieDate3Seconds,
  clearCookies,
  toLogin,
  getCookie,
  setCookie,
  setCookies,
  openLink,
  tracker,
  viewImage,
  ensureLogin,
  dateFormat,
  getDomain,
  isLeYou,
  CUSTOME_TRACE_ID
}
